/**
 * Estética compartida de superficies UDV (diálogos / paneles).
 * Oscuro clínico, bordes sutiles, tipografía compacta — acorde edge/classic.
 */
export const UDV_SURFACE = {
  paper: {
    background: 'linear-gradient(165deg, #1a1f27 0%, #12161c 55%, #0e1218 100%)',
    color: '#e8eef4',
    borderRadius: 12,
    border: '1px solid rgba(100, 181, 246, 0.18)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.35)',
    overflow: 'hidden',
  },
  title: {
    color: '#f0f4f8',
    fontWeight: 600,
    fontSize: '1.05rem',
    letterSpacing: '0.01em',
    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
    paddingBottom: 10,
    paddingTop: 14,
  },
  content: {
    color: 'rgba(230, 237, 243, 0.92)',
    paddingTop: 14,
  },
  muted: {
    color: 'rgba(180, 195, 210, 0.85)',
  },
  actions: {
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    padding: '10px 16px 14px',
    background: 'rgba(0, 0, 0, 0.2)',
  },
  btnPrimary: {
    background: 'linear-gradient(180deg, #42a5f5 0%, #1e88e5 100%)',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    boxShadow: 'none',
  },
  btnGhost: {
    color: 'rgba(230, 237, 243, 0.9)',
    textTransform: 'none',
    borderRadius: 8,
  },
  btnDanger: {
    color: '#ff8a80',
    textTransform: 'none',
    borderRadius: 8,
  },
  listItem: {
    borderRadius: 8,
    marginBottom: 4,
    border: '1px solid rgba(255, 255, 255, 0.04)',
    background: 'rgba(255, 255, 255, 0.03)',
  },
  backdrop: {
    backgroundColor: 'rgba(6, 10, 16, 0.72)',
    backdropFilter: 'blur(4px)',
  },
}

export const udvDialogProps = {
  PaperProps: { style: UDV_SURFACE.paper, className: 'udv-dlg-paper' },
  BackdropProps: { style: UDV_SURFACE.backdrop },
  style: { zIndex: 300220 },
}
